module.exports = __webpack_public_path__ + "8084aac14a4896460e31f17a3473fad6.svg";